module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/portfolio-single-7-5442ba9af54c278b2c5456d7c83d941c.jpg";